import { useState } from 'react'
import { BaseProps, ImageData } from '@/types/common'
import { getBrandStoryContent } from '@/content/siteContent'

// Import images
import teaLeafField from '@/assets/images/tea-leaf-field.png'
import flatLayArrangement from '@/assets/images/flat-lay-arrangement-with-tea-cups-herbs-1.png'

interface BrandStoryProps extends BaseProps {}

const BrandStory = ({ lang }: BrandStoryProps) => {
  const [hoveredImage, setHoveredImage] = useState<string | null>(null)
  const content = getBrandStoryContent(lang)

  const imageData: ImageData[] = [
    {
      id: 'story',
      title: content.cards[0].title,
      image: teaLeafField,
      alt: content.cards[0].alt,
    },
    {
      id: 'knowledge',
      title: content.cards[1].title,
      image: flatLayArrangement,
      alt: content.cards[1].alt,
    },
  ]

  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Images Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          {imageData.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer transform transition-all duration-300 hover:-translate-y-2"
              onMouseEnter={() => setHoveredImage(item.id)}
              onMouseLeave={() => setHoveredImage(null)}
            >
              <div className="relative overflow-hidden shadow-xl bg-white group-hover:shadow-2xl transition-shadow duration-300">
                <div className="relative w-full h-[420px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className={`w-full h-full object-cover transition-all duration-700 ease-out ${
                      hoveredImage === item.id 
                        ? 'transform scale-110' 
                        : 'transform scale-100'
                    }`}
                    style={{
                      transformOrigin: 'center center'
                    }}
                  />
                  
                  <div className={`absolute inset-0 border-4 border-green-400 transition-opacity duration-300 ${
                    hoveredImage === item.id ? 'opacity-100' : 'opacity-0'
                  }`} />

                  <div className="absolute inset-0 flex items-center justify-center">
                    <h3 className="text-4xl font-normal text-white text-center drop-shadow-lg">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Header Section */}
        <div className="text-center">
          <h2 className="text-[32px] font-semibold text-gray-800 mb-6">
            {content.heading}
          </h2>
          <p className="text-[16px] text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
            {content.body}
          </p>
          <div className="w-24 h-1 bg-gray-400 mx-auto"></div>
        </div>
      </div>
    </section>
  )
}

export default BrandStory
